import { Button, Space, Typography } from 'antd';
import React, { ReactNode } from 'react'

type Props = {
  title: string;
  additionalNode?: ReactNode;
  additionalInfo?: ReactNode;
}

export const PageHeader = ({ title, additionalInfo }: Props) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
      <div>
        <Space>
          <Typography.Title level={3}>{title}</Typography.Title>
          {additionalInfo}
        </Space>
      </div>
  
    </div>
  )
}
